module.exports = __webpack_public_path__ + "img/cappucino.a28f15c7.png";